import store from './index'
import { _http, _api, util } from '@/libs'

//项目整体框架存储
store.registerModule('ivew', {
  namespaced: true,
  state: {

    // 页面主题缓存
    frame: JSON.parse(localStorage.getItem('frame')) || { layout: true, theme: 'light' },
    breadcrumb: {
      list: [],
      category: [],
      page: ''
    },
    config: { baseJson: { loginBgImg: [] } },
    setUpFrontConfig: {},
    setupFrontList: []
  },
  mutations: {
    // 设置面包导航数据和菜单数据
    SET_BREADCRUMB_DATA(state, to) {
      state.breadcrumb.list = to.matched
      const menu = []
      store.state.sysUser.menu.forEach(item => {
        if(!item.children.every(item => item.menu == false)) {
          menu.push(item)
        }
      })
      menu.map((item, index) => {
        if (item.url == to.path.substr(util.findStrByCha(to.path, 2, '/') + 1, util.findStrByCha(to.path, 3, '/') - util.findStrByCha(to.path, 2, '/') - 1)) {
          item.children.map((node, nodeIndex) => {
            if (node.url == to.path.substr(util.findStrByCha(to.path, 3, '/') + 1)) {
              state.breadcrumb.category.push(item.url + index)
              if (node.menu == undefined || node.menu) {
                state.breadcrumb.page = node.url + index + nodeIndex
              } else if (node.active_url) {
                state.breadcrumb.page = node.active_url + index + item.children.findIndex(nodeFind => nodeFind.url == node.active_url)
              }
            }
          })
        }
      })
    },

    // 设置菜单样式和宽度
    SET_FRAME_STORAGE_DATA(state, frame) {
      state.frame = frame
      localStorage.setItem('frame', JSON.stringify(frame))
    },

    SET_CONFIG_DATA(state, payload) {
      state.config = payload
    },
    SET_UP_FRONT_CONFIG_DATA(state, payload) {
      state.setUpFrontConfig = payload
    },
    SET_SET_UP_FRONT(state, payload) {
      state.setupFrontList = payload
    },
  },

  actions: {

    // 获取前端配置文件
    getSiteSetUpFront(store) {
      return _http.get(_api.common.libSass.siteSetUpFront, { params: { dataKey: society_api.getAttribute('data-front-role') } }).then(payload => store.commit('SET_CONFIG_DATA', payload))
    },
    // 获取前端配置文件-全部作为一个json
    getSiteSetUpFrontAll(store) {
      return _http.get(_api.common.libSass.siteSetUpFrontAll).then(payload => store.commit('SET_UP_FRONT_CONFIG_DATA', payload))
    },
    //获取SaasSiteSetupFront配置信息列表
    getSaasSiteSetupFront(store, param) {
      return _http.get(_api.sys.sys.getSaasSiteSetupFront).then(payload => store.commit('SET_SET_UP_FRONT', payload))
    },
    //设置SaasSiteSetupFront配置信息
    setSaasSiteSetupFront(store, params) {
      return _http.post(_api.sys.sys.setSaasSiteSetupFront, params)
    },
  }
})